import type { Ref } from 'vue'
import { useToast } from '@/stores/toastStore'

export interface Response {
  status?: number
  message?: string
}

interface ApiResponse {
  value?: Response
}

interface ApiResult {
  response: ApiResponse | null
  result: ApiResponse | null
  error: ApiResponse | null
}

export const handleApiResponse = (
  responseCode: Ref<number>,
  responseMessage: Ref<string>,
  showSnackbar: Ref<boolean>,
  apiResult: ApiResult,
) => {
  const response = apiResult.response?.value
  const result = apiResult.result?.value
  const error = apiResult.error?.value

  if (response?.status !== 403) {
    responseCode.value = response?.status ?? 500
    responseMessage.value =
      result?.message ??
      (typeof error?.message === 'object'
        ? (error?.message as { message?: string })?.message
        : error?.message) ??
      ''
    showSnackbar.value = true
  } else {
    responseCode.value = 403
    responseMessage.value =
      result?.message ??
      (typeof error?.message === 'object'
        ? (error?.message as { message?: string })?.message
        : error?.message) ??
      'Você não tem permissão para realizar esta ação.'
    showSnackbar.value = true
  }
}

export const convertResponseToApiResponse = (
  response: Response | null,
): ApiResponse | null => {
  if (response) {
    return {
      value: {
        status: response.status,
        message: response.message,
      },
    }
  }
  return null
}

export const processApiResponse = (
  responseCode: Ref<number>,
  responseMessage: Ref<string>,
  showSnackbar: Ref<boolean>,
  dataResponse: Ref<Response | null>,
  dataResult: Ref<Response | null>,
  errorResult: Ref<Response | null>,
) => {
  handleApiResponse(responseCode, responseMessage, showSnackbar, {
    response: convertResponseToApiResponse(dataResponse.value),
    result: convertResponseToApiResponse(dataResult.value),
    error: convertResponseToApiResponse(errorResult.value),
  })
}

export const showApiToastDirect = (
  code: Ref<number>,
  message: Ref<string>,
  show: Ref<boolean> = ref(true),
) => {
  const useToastStore = useToast()
  const { showSnackbar, responseCode, responseMessage } =
    storeToRefs(useToastStore)

  responseCode.value = code.value
  responseMessage.value = message.value
  showSnackbar.value = show.value
}
